module.exports = __webpack_public_path__ + "static/media/mt7.c9e5301a.jpg";